import {
  afterNextRender,
  Component,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  input,
  output,
  viewChild,
} from '@angular/core';
import type { Maintenance } from '@models/maintenance.model';
import { DateRangePipe } from '@pipes/date-range.pipe';

@Component({
  selector: 'app-global-banner',
  imports: [DateRangePipe],
  templateUrl: './global-banner.component.html',
  styleUrl: './global-banner.component.css',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class GlobalBannerComponent {
  private readonly banner = viewChild.required<ElementRef<HTMLElement>>('banner');

  readonly maintenance = input.required<Maintenance>();
  readonly dismiss = output();

  constructor() {
    afterNextRender({
      write: () => {
        this.banner().nativeElement.showPopover();
      },
    });
  }
}
